import EventEmitter from 'eventemitter3'
import jwtDecode from 'jwt-decode'
import {store} from "../store/store.js";


class AuthService {

  constructor() {
    this.isAuthenticated = this.isAuthenticated.bind(this)
    this.authenticated = this.isAuthenticated()
    this.authNotifier = new EventEmitter()
  }

  isAuthenticated() {
    const now = new Date().getTime()
    const expiresAt = Number(localStorage.getItem('expires_at'))
    let storedUser = null
    try {
      storedUser = JSON.parse(localStorage.getItem('user'))
    } catch (error) {
      localStorage.removeItem('user')
    }

    let refreshValid = false
    try {
      refreshValid = Boolean(
        storedUser?.refresh_token && jwtDecode(storedUser.refresh_token).exp * 1000 > now
      )
    } catch (error) {
      refreshValid = false
    }

    const sessionValid = Boolean(storedUser && (expiresAt > now || refreshValid))
    if (!sessionValid) {
      localStorage.removeItem('expires_at')
      localStorage.removeItem('user')
      return false
    }

    if (store.state.auth.user === null) store.dispatch('getUserProfile', null)
    return true
  }
}

export default AuthService
